import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../AppContextProvider";
import { useWalletProvider } from "../../walletprovider/useWalletProvider";
import ProfileJsonStorage from "../../utils/storage/profileJsonStorage";
import FeedbackJsonStorage from "../../utils/feedback/feedbackJsonStorage";
import UseraddressJsonStorage from "../../utils/useraddress/useraddressJsonStorage";
import { AvalancheContext, useAvalancheProvider } from "../../avalanche/AvalancheProvider";
import { WalletProviderContext } from "../../walletprovider/WalletProvider";
import { createStorageJson } from "../../utils/useraddress/useraddressJsonConvert";
import TableComponent from "./TableComponent";
import WhiteUserTable from "./WhiteUserTable";
import UserlistWithOnboarding from "./UserlistWithOnboarding";
import { WarningTicket, NotificationsTicket } from "../../components/TicketsComponent";
import {
  collectLog,
  createEmptyLogsAndVars,
  dwReportError,
  recordVariable,
} from "../../utils/diagnostics/clientErrors";

import filter_alt from "../../assets/media/icons/filter-alt.svg";
import cross_invert from "../../assets/media/icons/cross-invert.svg";
import tag from "../../assets/media/icons/tag.svg";
import cross_invert_color from "../../assets/media/icons/cross-invert-color.svg";
import tag_color from "../../assets/media/icons/tag-color.svg";

import {
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBTabs,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsContent,
  MDBTabsPane,
  MDBSelect,
} from "mdb-react-ui-kit";
import { DwMpcWalletBackendProviderContext } from "../../mpcwalletprovider/DwMpcWalletBackendProvider";

function AdminPage(props) {
  const navigate = useNavigate();
  const context = useContext(AppContext);
  const { selectedAccount } = useWalletProvider();
  const avalancheContext = useContext(AvalancheContext);
  const feedbackJsonStorage = FeedbackJsonStorage.create(avalancheContext);
  const useraddressJsonStorage = UseraddressJsonStorage.create(avalancheContext);
  const walletContext = useContext(WalletProviderContext);
  const { storageProps } = useContext(DwMpcWalletBackendProviderContext);
  const [feedbackArray, setFeedbackArray] = useState([]);
  const [useraddressArray, setUseraddressArray] = useState([]);
  const [feedbackId, setFeedbackId] = useState(0);
  const [isAddNew, setIsAddNew] = useState(false);
  const [walletaddress, setWalletaddress] = useState("");
  const [basicActive, setBasicActive] = useState("tab1");
  const [roleName, setRoleName] = useState("extern");
  //const [isDoneTicket, setIsDoneTicket] = useState(false);

  const getAccount = async () => {
    const logsAndVars = createEmptyLogsAndVars("AdminPage:getAccount");
    try {
      const res = await feedbackJsonStorage.getAllFeedback();
      recordVariable(logsAndVars, "getAllFeedback result", res);
      recordVariable(logsAndVars, "props.isOwnFeedback", props.isOwnFeedback);

      if (props.isOwnFeedback) {
        setFeedbackArray(
          res.filter((k) => k.feedback && k.feedback.date !== "" && k.address === selectedAccount).reverse(),
        );
        context.onSetLoaderFalse();
        collectLog(logsAndVars, "starting getWhiteUserList");
        getWhiteUserList();
        collectLog(logsAndVars, "getWhiteUserList is done");
      } else {
        setFeedbackArray(res.filter((k) => k.feedback && k.feedback.date !== "").reverse());
        context.onSetLoaderFalse();
        collectLog(logsAndVars, "starting getWhiteUserList");
        getWhiteUserList();
        collectLog(logsAndVars, "getWhiteUserList is done");
      }
    } catch (error) {
      dwReportError(selectedAccount, storageProps.portalClientId, error, { logsAndVars });
      console.log(error);
    }
  };

  const getWhiteUserList = async () => {
    const logsAndVars = createEmptyLogsAndVars("AdminPage:getWhiteUserList");
    try {
      const res = await useraddressJsonStorage.getAllUserAddress();
      recordVariable(logsAndVars, "getAllUserAddress result", res);
      setUseraddressArray(res);
      context.onSetLoaderFalse();
    } catch (error) {
      dwReportError(selectedAccount, storageProps.portalClientId, error, { logsAndVars });
      console.log(error);
    }
  };

  const deleteUserFromList = async (id) => {
    const logsAndVars = createEmptyLogsAndVars("AdminPage:deleteUserFromList");
    recordVariable(logsAndVars, "useraddressArray (state)", useraddressArray);
    try {
      const selectedUser = useraddressArray.filter((k) => k.useraddress.address === id)[0];
      recordVariable(logsAndVars, "selectedUser", selectedUser);
      selectedUser.useraddress.address = "";
      useraddressJsonStorage.updateUseraddressData(selectedUser);
      collectLog(logsAndVars, "updateUseraddressData");
      context.onSetLoaderTrue();
      setTimeout(() => {
        getWhiteUserList();
        context.onSetIsRender();
      }, 1000);
      setTimeout(() => {
        context.onSetIsRender();
      }, 1000);
    } catch (ex) {
      dwReportError(selectedAccount, storageProps.portalClientId, ex, { logsAndVars });
      console.log(ex);
    }
  };

  const saveUserToList = async (e) => {
    e.preventDefault();
    const logsAndVars = createEmptyLogsAndVars("AdminPage:saveUserToList");
    try {
      recordVariable(logsAndVars, "walletaddress", walletaddress);
      recordVariable(logsAndVars, "roleName", roleName);
      useraddressJsonStorage.createUseraddressData(createStorageJson(walletaddress, walletaddress, roleName, false));
      collectLog(logsAndVars, "createUseraddressData is done");
      context.onSetLoaderTrue();
      setTimeout(() => {
        getWhiteUserList();
        context.onSetIsRender();
      }, 3000);
      setTimeout(() => {
        context.onSetIsRender();
        setIsAddNew(false);
      }, 3000);
    } catch (ex) {
      dwReportError(selectedAccount, storageProps.portalClientId, ex, { logsAndVars });
      console.log(ex);
    }
  };

  const selectFeedback = (id, isDelete) => {
    const selectedFeedback = feedbackArray[id];

    if (selectedFeedback) {
      if (!isDelete) {
        if (selectedFeedback.feedback.isUnread === true) {
          selectedFeedback.feedback.isUnread = false;
          context.onSetLoaderTrue();
          saveFeedback(selectedFeedback);
          setTimeout(() => {
            getAccount();
            setFeedbackId(id);
          }, 4000);
          setTimeout(() => {
            context.onSetIsRender();
          }, 4500);
        } else {
          setFeedbackId(id);
        }
      } else {
        feedbackArray.splice(id, 1);
        selectedFeedback.feedback.isUnread = false;
        //selectedFeedback.feedback.from_email = "";
        selectedFeedback.feedback.date = "";
        //selectedFeedback.feedback.browser = "";
        //selectedFeedback.feedback.webpage = "";
        selectedFeedback.feedback.cleanMessage_1 = "";
        //selectedFeedback.feedback.cleanMessage_2 = "";
        //selectedFeedback.feedback.cleanMessage_3 = "";
        //selectedFeedback.feedback.question_1 = -1;
        //selectedFeedback.feedback.question_2 = -1;
        //selectedFeedback.feedback.question_3 = -1;
        //selectedFeedback.feedback.question_4 = -1;
        //selectedFeedback.feedback.question_5 = -1;
        //selectedFeedback.feedback.question_6 = -1;
        //selectedFeedback.feedback.question_7 = -1;
        //selectedFeedback.feedback.question_8 = -1;
        //selectedFeedback.feedback.question_9 = -1;
        //selectedFeedback.feedback.question_10 = -1;
        saveFeedback(selectedFeedback);
        context.onSetLoaderTrue();
        setTimeout(() => {
          getAccount();
          context.onSetIsRender();
        }, 3000);
        setTimeout(() => {
          context.onSetIsRender();
          //setIsDoneTicket(true);
          //context.openModal("messagemodal", "Deleted sucessfully!");
        }, 3000);
      }
    }
  };

  const saveFeedback = async (jsonObj) => {
    const logsAndVars = createEmptyLogsAndVars("AdminPage:saveFeedback");
    recordVariable(logsAndVars, "jsonObj (param)", jsonObj);
    try {
      feedbackJsonStorage.updateFeedbackData(jsonObj);
      collectLog(logsAndVars, "updateFeedbackData is done");
    } catch (ex) {
      dwReportError(selectedAccount, storageProps.portalClientId, ex, { logsAndVars });
      console.log(ex);
    }
  };

  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    }

    setBasicActive(value);
  };

  useEffect(() => {
    getAccount();
  }, []);

  return (
    <div className={props.isOwnFeedback ? "admin-tabs settings" : "admin-tabs"}>
      {window.location.pathname === "/admin" && (
        <>
          <UserlistWithOnboarding />
          <div className="admin-title-text">
            <span className="title-text">Admin area</span>
            <button type="button" className="button large outline" onClick={() => navigate("/files")}>
              <span className="text">Back to Application</span>
            </button>
          </div>
          <MDBTabs className="mb-3">
            <MDBTabsItem>
              <MDBTabsLink onClick={() => handleBasicClick("tab1")} active={basicActive === "tab1"}>
                Feedbacks
              </MDBTabsLink>
            </MDBTabsItem>

            <MDBTabsItem>
              <MDBTabsLink onClick={() => handleBasicClick("tab2")} active={basicActive === "tab2"}>
                User Whitelist
              </MDBTabsLink>
            </MDBTabsItem>
          </MDBTabs>
        </>
      )}
      <MDBTabsContent>
        <MDBTabsPane show={basicActive === "tab1"}>
          <div>
            {feedbackArray.length > 0 ? (
              <div className={"dashboard-admin"}>
                <div className="table-div">
                  <TableComponent
                    feedbackArray={feedbackArray}
                    setFeedbackId={(id, isDelete) => selectFeedback(id, isDelete)}
                  />
                </div>
                <div className="feeback-div">
                  <MDBCard>
                    <MDBCardHeader>{feedbackArray[feedbackId]?.feedback.date}</MDBCardHeader>
                    <MDBCardBody>
                      {/*
                      <div>
                        <p>
                          <span>Email from: </span>
                          {feedbackArray[feedbackId]?.feedback.from_email}
                        </p>
                        <p>
                          <span>Wallet Adress: </span>
                          {feedbackArray[feedbackId]?.address}
                        </p>
                        <p>
                          <span>Browser: </span>
                          {feedbackArray[feedbackId]?.feedback.browser}
                        </p>
                        <p className="mb-5">
                          <span>Site: </span>
                          {feedbackArray[feedbackId]?.feedback.webpage}
                        </p>
                        <p>
                          <span>1. How easy or difficult was the onboarding process?</span>
                        </p>
                        <p>{feedbackArray[feedbackId]?.feedback.question_1}</p>
                        <p>
                          <span>2. Were there any difficulties or uncertainties during the registration process?</span>
                        </p>
                        <p>{feedbackArray[feedbackId]?.feedback.question_2 === 2 ? "Yes" : "No"}</p>
                        {feedbackArray[feedbackId]?.feedback.cleanMessage_1 && (
                          <p>
                            <span>Message:</span>
                          </p>
                        )}
                        <p>{feedbackArray[feedbackId]?.feedback.cleanMessage_1}</p>
                        <p>
                          <span>3. How clear did you find the instructions for connecting your wallet?</span>
                        </p>
                        <p>{feedbackArray[feedbackId]?.feedback.question_3}</p>
                        <p>
                          <span>{"4. How well do you understand the concept of 'gas fees'?"}</span>
                        </p>
                        <p>{feedbackArray[feedbackId]?.feedback.question_4}</p>
                        <p>
                          <span>5. Did you feel safe connecting your wallet to our service?</span>
                        </p>
                        <p>{feedbackArray[feedbackId]?.feedback.question_5 === 1 ? "Yes" : "No"}</p>
                        {feedbackArray[feedbackId]?.feedback.cleanMessage_2 && (
                          <p>
                            <span>Message:</span>
                          </p>
                        )}
                        <p>{feedbackArray[feedbackId]?.feedback.cleanMessage_2}</p>
                        <p>
                          <span>
                            6. How do you rate the transparency and traceability of data management on this platform?
                          </span>
                        </p>
                        <p>{feedbackArray[feedbackId]?.feedback.question_6}</p>
                        <p>
                          <span>
                            7. How well informed do you feel about the general functioning of our Web3 service?
                          </span>
                        </p>
                        <p>{feedbackArray[feedbackId]?.feedback.question_7}</p>
                        {/*
                        <p>
                          <span>
                            8. How would you rate the usability of the platform for uploading and managing data?
                          </span>
                        </p>
                        <p>{feedbackArray[feedbackId]?.feedback.question_8}</p>
                        */}
                      {/*<p>
                          <span>
                            8. Do you have any suggestions for improving the onboarding process or user guidance?
                          </span>
                        </p>
                        {feedbackArray[feedbackId]?.feedback.cleanMessage_3 && (
                          <p>
                            <span>Message:</span>
                          </p>
                        )}
                        <p>{feedbackArray[feedbackId]?.feedback.cleanMessage_3}</p>
                        <p>
                          <span>9. How likely is it that you will recommend this platform to others?</span>
                        </p>
                        <p>{feedbackArray[feedbackId]?.feedback.question_9}</p>
                        <p>
                          <span>
                            10. How reasonable do you think the envisaged price of USD 100 per year for the standard
                            license is?
                          </span>
                        </p>
                        <p>{feedbackArray[feedbackId]?.feedback.question_10}</p>
                      </div>
                      */}
                      <div>
                        {feedbackArray[feedbackId]?.feedback.cleanMessage_1 && (
                          <p>
                            <span>Message:</span>
                          </p>
                        )}
                        <p style={{ whiteSpace: "pre-wrap" }}>
                          {feedbackArray[feedbackId]?.feedback.cleanMessage_1.replaceAll("…", "")}
                        </p>
                      </div>
                    </MDBCardBody>
                  </MDBCard>
                </div>
              </div>
            ) : (
              <div className={"dashboard-admin"}>Feedback not available</div>
            )}
          </div>
        </MDBTabsPane>
        <MDBTabsPane show={basicActive === "tab2"}>
          <div>
            <div className={"dashboard-admin-wallet"}>
              <div className="whitelist-title">
                <span>Whitelisted wallet addresses</span>
              </div>
              <button type="button" className="button accent large" onClick={() => setIsAddNew(true)}>
                <span className="text p18x">+ Add address</span>
              </button>
              {isAddNew && (
                <div className="wallet-div">
                  <form className="profile-form" autoComplete="off" onSubmit={(e) => saveUserToList(e)}>
                    <div className="form-row">
                      <div className="div-2">
                        <div className="actions-div whitelist ms-2">
                          <MDBSelect
                            data={[
                              { text: "admin", value: 1 },
                              { text: "intern", value: 2 },
                              { text: "extern", value: 3 },
                            ]}
                            onValueChange={(val) => setRoleName(val.text)}
                            label={
                              <div className="multiselect-div">
                                <img src={filter_alt} alt="filter" />
                                <span>Role filter</span>
                              </div>
                            }
                          />
                          {window.innerWidth > 992 && <div className="spacer" />}
                          <div className="filter-div">
                            <span className="filter-title">Role:</span>
                            <div className="tags-div-2">
                              <img src={tag_color} alt="tag" />
                              <span>{roleName}</span>
                              <img src={cross_invert_color} alt="cross-invert" />
                            </div>
                          </div>
                          {window.innerWidth > 992 && <div className="spacer" />}
                        </div>
                        <label htmlFor="wallettaddressl" className="navbar-text">
                          Walletaddress
                        </label>
                        <input
                          id="walletaddress"
                          name="name"
                          placeholder="User walletaddress"
                          className="input-text"
                          type="text"
                          onChange={(event) => setWalletaddress(event.target.value.toLowerCase())}
                          value={walletaddress}
                          tabIndex="0"
                          required
                        />
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="div-3">
                        <button
                          type="button"
                          className="button subtle medium"
                          onClick={() => setIsAddNew(false)}
                          tabIndex="-1"
                        >
                          <div className="text p15">Cancel</div>
                        </button>
                        <button type="submit" className="button brand medium" tabIndex="0">
                          <div className="text p15">Submit</div>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              )}
              {useraddressArray.length > 0 && (
                <div className="whitelist-div">
                  <WhiteUserTable
                    useraddressArray={useraddressArray}
                    deleteUserFromList={(id) => deleteUserFromList(id)}
                    feedbackArray={feedbackArray}
                  />
                </div>
              )}
            </div>
          </div>
        </MDBTabsPane>
      </MDBTabsContent>
    </div>
  );
}

export default AdminPage;
